<template>
  <div>
    <div v-loading="loading">
      <app-templates
        v-if="Object.keys(model.templates).length > 0"
        v-model="model.templates"
        :fixed="false"
        :hide-add-button="true"
        @delete="removeTemplate"
        @edit="openEditTemplateDialog"
        @add="openAddTemplateDialog"
      />

      <ui-alert-message-no-data v-else />

      <ui-button-float
        variant="success"
        @click.prevent="openAddTemplateDialog"
      />
    </div>

    <!-- EDIT TEMPLATE DIALOG -->
    <b-modal
      :title="$t('Edit object', { object: $tc('Templates', 1) })"
      :visible="editTemplateVisible"
      @hide="closeEditTemplateDialog"
    >
      <app-template-form
        v-model="editTemplateModel"
        :marketplace-id="$marketplace_id"
      />
      <template slot="modal-footer">
        <button
          class="btn btn-primary"
          @click.prevent="saveTemplate"
        >
          {{ $t('Save') }}
        </button>
      </template>
    </b-modal>

    <!-- ADD TEMPLATE DIALOG -->
    <b-modal
      :title="$t('Add object', { object: $tc('Templates', 1) })"
      :visible="addTemplateVisible"
      @hide="closeAddTemplateDialog"
    >
      <app-template-form
        v-model="addTemplateModel"
        :marketplace-id="$marketplace_id"
        change-key
      />
      <template slot="modal-footer">
        <button
          class="btn btn-primary"
          @click.prevent="addTemplate"
        >
          {{ $t('Add') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import MarketplaceMixins from '../mixins/MarketplaceMixins';
import AppTemplates from '../components/templates/Templates.vue';
import AppTemplateForm from '../components/templates/TemplateForm.vue';

export default {
  name: 'AppPageMarketplaceTemplates',
  components: { AppTemplates, AppTemplateForm },
  mixins: [
    MarketplaceMixins,
  ],
  data() {
    return {
      loading: false,
      /**
         * Edit a template params
         */
      editTemplateModel: {},
      editTemplateVisible: false,
      /**
         * Add a template params
         */
      addTemplateModel: {},
      addTemplateVisible: false,
    };
  },
  mounted() {
    this.$marketplace_load(this.$marketplace_getRouteId());
  },
  methods: {
    /**
       * Removes a template with specify key.
       * @param {string} key Template Key
       */
    removeTemplate(key) {
      // eslint-disable-next-line
      if (confirm(this.$t('Are you sure?'))) {
        const model = { ...this.model };
        model.templates = {};
        Object.keys(this.model.templates).forEach(e => {
          if (e !== key) {
            model.templates[e] = this.model.templates[e];
          }
        });
        this.model = model;
        this.$marketplace_save().then(() => {
          this.$marketplace_load(this.$marketplace_getRouteId());
        });
      }
    },
    /**
       * Opens a modal dialog with a form for editing a template.
       * @param {string} key Template Key
       */
    openEditTemplateDialog(key) {
      this.editTemplateModel = { key, ...this.model.templates[key] };
      this.editTemplateVisible = true;
    },
    /**
       * Closes a modal dialog with a form for editing a template.
       */
    closeEditTemplateDialog() {
      this.editTemplateVisible = false;
    },
    /**
       * Saving a template.
       * Actually only change a template information in a model.
       */
    saveTemplate() {
      const model = { ...this.model };
      const { key } = this.editTemplateModel;
      delete this.editTemplateModel.key;
      model.templates[key] = this.editTemplateModel;
      this.model = model;
      this.closeEditTemplateDialog();
      this.$marketplace_save().then(() => {
        this.$marketplace_load(this.$marketplace_getRouteId());
      });
    },
    /**
       * Opens a modal dialog with a form for editing a template.
       */
    openAddTemplateDialog() {
      this.addTemplateModel = {
        key: '',
        name: '',
        description: '',
        default: '',
        required: false,
        type: 'field',
      };
      this.addTemplateVisible = true;
    },
    /**
       * Closes a modal dialog with a form for editing a template.
       */
    closeAddTemplateDialog() {
      this.addTemplateModel = {};
      this.addTemplateVisible = false;
    },
    addTemplate() {
      if (this.addTemplateModel.key.length > 0 && this.addTemplateModel.name.length > 0) {
        const model = { ...this.model };
        model.templates[this.addTemplateModel.key] = {
          name: this.addTemplateModel.name,
          description: this.addTemplateModel.description,
          default: this.addTemplateModel.default,
          required: this.addTemplateModel.required,
          type: this.addTemplateModel.type,
        };
        this.model = model;
      }
      this.closeAddTemplateDialog();
      this.$marketplace_save().then(() => {
        this.$marketplace_load(this.$marketplace_getRouteId());
      });
    },
  },
};
</script>
